import palette from '@mlc/mlc-palette';
import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ScreenSize } from '../../../../enums';

type ListAnchorProps = {
	showRaisedLink?: boolean;
	isActive: boolean;
};

export const getBackgroundColor = (
	isActive?: boolean,
	override: boolean = false
) => {
	if (isActive) {
		return `${palette.mlcKoala}${override ? ' !important' : ''}`;
	}
	return 'transparent';
};

export const getTextLinkColor = (
	isActive?: boolean,
	override: boolean = false
) => {
	if (isActive) {
		return `${palette.mlcTextLink}${override ? ' !important' : ''}`;
	}
	return `${palette.mlcText}${override ? ' !important' : ''}`;
};

const linkStyles = (props: ListAnchorProps) => {
	return {
		height: 'auto',
		display: 'flex',
		flex: 1,
		alignItems: 'center',
		boxShadow: props.showRaisedLink ? '0 0.5rem 1rem rgba(0,0,0,.175)' : '0',
		backgroundColor: getBackgroundColor(props.showRaisedLink),
		transition: 'all 0.25s linear',
		padding: '5px 15px',
		color: getTextLinkColor(props.showRaisedLink || props.isActive),
		textDecoration: props.showRaisedLink ? 'underline' : 'none',
		borderTop: '2px transparent solid',
		borderBottom: '2px transparent solid',

		'&:focus, &:hover': {
			color: palette.mlcTextLink,
		},

		[`@media (max-width: ${ScreenSize.large})`]: {
			paddingLeft: 10,
			paddingRight: 10,
		},

		[`@media (max-width: ${ScreenSize.medium})`]: {
			paddingBottom: 0,
			paddingLeft: 10,
			paddingTop: 0,
		},

		[`@media (max-width: ${ScreenSize.small})`]: {
			backgroundColor: getBackgroundColor(props.showRaisedLink, true),
			color: getTextLinkColor(props.showRaisedLink || props.isActive),
			paddingBottom: 0,
			paddingLeft: 10,
			paddingTop: 4,
		},

		[`@media (max-width: ${ScreenSize.xSmall})`]: {
			backgroundColor: getBackgroundColor(props.showRaisedLink, true),
			color: getTextLinkColor(props.showRaisedLink || props.isActive),
			padding: '0 0 0 1rem',
		},
	};
};

export const RouterNavLink = styled(
	({ isActive, showRaisedLink, ...restProps }) => <Link {...restProps} />
)`
	${props => linkStyles(props)}
`;
export const AnchorNavLink = styled(
	({ isActive, showRaisedLink, ...restProps }) => <a {...restProps} />
)`
	${props => linkStyles(props)}
`;
